/*
    Helpers library by Anton Zolotov (antonzolotov@outlook.com)
*/
export function getCurrentLanguage(): string {
    try {
        if (typeof window !== "undefined" && window && window.Intl && typeof window.Intl === "object") {
            // console.log(window.Intl.DateTimeFormat().resolvedOptions().locale)
            return window.Intl.DateTimeFormat().resolvedOptions().locale.slice(0, 2)
        }
        else
            return import.meta.env.VITE_I18N_LOCALE ? import.meta.env.VITE_I18N_LOCALE : "en"
    }
    catch (error) {
        return import.meta.env.VITE_I18N_LOCALE ? import.meta.env.VITE_I18N_LOCALE : "en"
    }
}


export function flattenObject(obj: Record<string, any>, parentKey: string = "", result: Record<string, any> = {}): Record<string, any> {
    const hasOwnProperty = Object.prototype.hasOwnProperty

    for (const key in obj) {
        if (hasOwnProperty.call(obj, key)) {
            const newKey = parentKey ? `${parentKey}.${key}` : key
            if (typeof obj[key] === "object" && obj[key] !== null && !Array.isArray(obj[key])) {
                flattenObject(obj[key], newKey, result)
            }
            else {
                result[newKey] = obj[key]
            }
        }
    }
    return result
}

export function getThousandSeparator(locale?: string): string {
    if (!locale)
        locale = getCurrentLanguage()
    const formatter = new Intl.NumberFormat(locale)
    const parts = formatter.formatToParts(1234)
    const groupSeparator = parts.find(part => part.type === "group")?.value

    return groupSeparator || "," // По умолчанию возвращаем запятую, если символ не найден
}

export function getDecimalSeparator(locale?: string): string {
    if (!locale)
        locale = getCurrentLanguage()
    const formatter = new Intl.NumberFormat(locale)
    const parts = formatter.formatToParts(1.1)
    const decimalSeparator = parts.find(part => part.type === "decimal")?.value

    return decimalSeparator || "." // По умолчанию возвращаем точку, если символ не найден
}

export function jsonToFormData(object: Record<string, any>): FormData {
    const formData = new FormData()
    for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
            if (object[key] instanceof File) {
                // Добавляем файлы
                formData.append(key, object[key])
            }
            else if (Array.isArray(object[key])) {
                // Если это массив, добавляем каждый элемент
                object[key].forEach((item, index) => {
                    formData.append(`${key}[${index}]`, item)
                })
            }
            else {
                // Добавляем обычные данные
                formData.append(key, object[key])
            }
        }
    }
    return formData
}

export function trimArray<T>(arr: T[] | undefined, limit: number): T[] {
    return Array.isArray(arr) ? arr.slice(0, limit) : []
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function once(fn: Function) {
    let called = false
    return function(this: any, ...args: any) {
        if (called) return
        called = true
        return fn.apply(this, args)
    }
}
